import { render, staticRenderFns } from "./PatientHeader.vue?vue&type=template&id=c6d199a0&"
import script from "./PatientHeader.vue?vue&type=script&lang=js&"
export * from "./PatientHeader.vue?vue&type=script&lang=js&"
import style0 from "./PatientHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports